module.exports = __webpack_public_path__ + "img/energy.13d5ed36.svg";